{
  "familyId": "SWW-BN-VD-KORT",
  "questions": [
    {
      "id": "SWW-BN-VD-KORT-001",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'de ... auto' (verbranden → als bijvoeglijk naamwoord)?",
      "context": null,
      "options": ["verbrande", "verbranden", "verbrandde", "verbrandene"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Bijvoeglijk Naamwoord van VD", "content": "Bij een lange klank laat je een klinker weg: verbrand (lange a) → verbrande (niet verbrandde).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_from_past_participle_long",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord van voltooid deelwoord (lange klank). Stap 1: Het voltooid deelwoord van 'verbranden' is 'verbrand'. Stap 2: 'Verbrand' heeft een lange 'a'. Stap 3: Bij een lange klank voeg je gewoon -e toe (geen verdubbeling): verbrand + e = verbrande. Checkstrategie: hoor je een lange klank? Dan NIET verdubbelen. Vergelijk: 'verbrandde' zou een korte klank suggereren — maar de 'a' in 'verbrand' is lang.",
        "distractorExplanations": {
          "0": "Correct! Lange klank → gewoon + e: verbrande (niet verbrandde).",
          "1": "Veelgemaakte fout: het hele werkwoord gebruiken als bijvoeglijk naamwoord. 'Verbranden' is het hele werkwoord. Als bijvoeglijk naamwoord: verbrande (voltooid deelwoord + e). Misconceptie: het werkwoord verwarren met het bijvoeglijk naamwoord.",
          "2": "Veelgemaakte fout: de medeklinker verdubbelen bij een lange klank. 'Verbrandde' heeft een dubbele d, maar dat hoort bij een korte klank. De 'a' in 'verbrand' is lang, dus geen verdubbeling: verbrande. Misconceptie: korte en lange klanken verwarren.",
          "3": "Veelgemaakte fout: een extra lettergreep toevoegen. 'Verbrandene' is te lang. De regel is: voltooid deelwoord + e = verbrande. Misconceptie: denken dat bijvoeglijke naamwoorden altijd -ene krijgen."
        }
      }
    },
    {
      "id": "SWW-BN-VD-KORT-002",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "context": null,
      "options": ["De geverfde muur ziet er mooi uit.", "De geverfden muur ziet er mooi uit.", "De geverfdde muur ziet er mooi uit.", "De geverfte muur ziet er mooi uit."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Bijvoeglijk Naamwoord van VD", "content": "Bij een lange klank laat je een klinker weg: geverfd (lange e) → geverfde (niet geverfdde).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_from_past_participle_geverfd",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord van voltooid deelwoord (lange klank). Stap 1: Het voltooid deelwoord van 'verven' is 'geverfd'. Stap 2: 'Geverfd' heeft een lange 'e'. Stap 3: Bij een lange klank voeg je gewoon -e toe: geverfd + e = geverfde. Checkstrategie: hoor je een lange klank? Dan NIET verdubbelen. De 'e' in 'geverfd' is lang, dus: geverfde.",
        "distractorExplanations": {
          "0": "Correct! Lange klank → gewoon + e: geverfde (niet geverfdde).",
          "1": "Veelgemaakte fout: -en gebruiken in plaats van -e. 'Geverfden' lijkt op een meervoudsvorm. Bijvoeglijke naamwoorden krijgen alleen -e: geverfde. Misconceptie: bijvoeglijk naamwoord verwarren met meervoud.",
          "2": "Veelgemaakte fout: de medeklinker verdubbelen bij een lange klank. 'Geverfdde' heeft een dubbele d, maar dat hoort bij een korte klank. De 'e' in 'geverfd' is lang, dus geen verdubbeling: geverfde. Misconceptie: korte en lange klanken verwarren.",
          "3": "Veelgemaakte fout: kofschip-regel toepassen op het bijvoeglijk naamwoord. 'Geverfte' gebruikt -te (alsof kofschip), maar het voltooid deelwoord is 'geverfd' (met d). Als bijvoeglijk naamwoord: geverfd + e = geverfde."
        }
      }
    }
  ]
}